import Button from "components/buttons/Button"
import Icon from "components/Icon"
import colors from "styles/colors"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const Tag: React.FC<ComponentProps> = ({
  className,
  color,
  iconColor = colors.white,
  label,
  onClick,
  onRemove
}) => (
  <Wrapper $color={color} className={className}>
    <Button
      color={color}
      label={label}
      noHoverHighlight
      noPadding
      onClick={onClick}
      small
    />

    {onRemove ? (
      <Button
        color={color}
        icon={<Icon color={iconColor} name="IoClose" size="16px" />}
        iconOnly
        label={`Remove ${label}`}
        noPadding
        onClick={onRemove}
        small
      />
    ) : null}
  </Wrapper>
)

export default Tag
